export const PRIORITY_OPTIONS = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export const STATUS_OPTIONS = ['OPEN', 'CANCELED', 'SOLVED', 'ERROR'];

export const DEFAULT_FILTERS = {
  priorities: [],
  statuses: [],
  createdDate: null,
  endTime: null,
};

export const STATUS = {
  OPEN: 'OPEN',
  CANCELED: 'CANCELED',
  SOLVED: 'SOLVED',
  ERROR: 'ERROR',
  INPROGRESS: 'INPROGRESS',
};

export const PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
};

export const statuses = [
  { name: 'Открыта', value: STATUS.OPEN },
  { name: 'Отменена', value: STATUS.CANCELED },
  { name: 'Выполнена', value: STATUS.SOLVED },
  { name: 'Ошибка', value: STATUS.ERROR },
  { name: 'В обработке', value: STATUS.INPROGRESS },
];

export const priorities = [
  { name: 'Низкий', value: PRIORITY.LOW },
  { name: 'Средний', value: PRIORITY.MEDIUM },
  { name: 'Высокий', value: PRIORITY.HIGH },
  { name: 'Критический', value: PRIORITY.CRITICAL },
];

export const statusesNames = {
  [STATUS.OPEN]: 'Открыта',
  [STATUS.CANCELED]: 'Отменена',
  [STATUS.SOLVED]: 'Выполнена',
  [STATUS.ERROR]: 'Ошибка',
  [STATUS.INPROGRESS]: 'В обработке',
};

export const prioritiesNames = {
  [PRIORITY.LOW]: 'Низкий',
  [PRIORITY.MEDIUM]: 'Средний',
  [PRIORITY.HIGH]: 'Высокий',
  [PRIORITY.CRITICAL]: 'Критический',
};
